import React from "react";

const RenewPayConfirmed = (props) => {
  
    return (
        <>
            <div className="new_paid">
                <h1 className="new_paid-title text-jost-sb-50-wt">Thank you for registering with Timely Golf</h1>

                <div className="new_paid__wrap">
                    <div className="new_paid__bar">
                        <ul className="new_paid__bar__row">
                            <li className="text-jost-sb-22 completed">CLUB Details</li>
                            <li className="text-jost-sb-22 completed ">Golf Courses</li>
                            <li className="text-jost-sb-22 completed">Payment DETAILS</li>
                            <li className="text-jost-sb-22 active">Confirmation</li>
                        </ul>
                    </div>
                    <div className="new_paid__box">
                        <div className="new_paid__box__sec1">
                            <h2 className="cpay__box__left-txt text-jost-sb-22">Payment Reference #29432240</h2>

                            <div className="new_paid-links">

                                <a href="/" target="_self" className="res-btn-lightgrn">Download invoice</a>
                            </div>


                        </div>
                        <div className="new_paid__box__sec2">
                            <p className="new_paid__box__sec2-txt text-ops-rg-16">Thank you message. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin eu mattis velit. Donec dictum leo vel fermentum placerat. Null  bibendum blandit. Praesent eu consequat dictum leovel Aenean consectetur sit amet sem non maximus. Praesent dictum, odio non posuere scelerisque, diam augue sagittis arcu, vitae egestas tortor ligula ut arcu sit amet sem non.</p>

                            <div className="new_paid__box__sec2-links">

                                <a href="/" target="_self" className="res-btn-primary">continue</a>
                            </div>


                        </div>


                    </div>
                </div>
            </div>
        </>
    );
};
export default RenewPayConfirmed;